import { IReviewStageState } from "../reducers/reviewStagesReducer";

export const selectReviewStages = ({ reviewStages: { stages } }: IReviewStageState) => stages || [];

export const selectReviewStagesLoader = ({ reviewStages }: IReviewStageState) =>
  reviewStages.loading;
